import { BaseMenu } from "./base-menu";

export class AspectMenu extends BaseMenu {
    faction: boolean = false;
    prototype: boolean = false;
    aspect: boolean = false;
}
